import * as React from 'react';

import {IconButton} from '../button/icon-button/icon-button';
import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CogIcon} from '../icon/svg/cog-icon';

import styles from './modal-action-button.module.css';

type Props = {
    onClick: () => void;
    tooltipText: string;
};

export function ModalActionButton(props: Props) {
    return (
        <div className={styles['action-button']}>
            <IconButton
                icon={() => <CogIcon size={24} color={colors.grey} />}
                onClick={props.onClick}
                noHoverBackground={true}
                tooltipText={props.tooltipText}
            />
        </div>
    );
}
